import React from 'react';

interface StatisticsSectionProps {
  title: string;
  statistics: {
    avg_price: number;
    available_trainers: number;
    response_time_min: number;
    response_time_max: number;
    has_remote: boolean;
    location_name: string;
  };
}

const StatisticsSection: React.FC<StatisticsSectionProps> = ({ title, statistics }) => {
  const formatResponseTime = () => {
    if (statistics.response_time_min === statistics.response_time_max) {
      return `${statistics.response_time_min}min`;
    }
    return `${statistics.response_time_min}-${statistics.response_time_max}min`;
  };

  const formatSessionForm = () => {
    if (statistics.has_remote) {
      return "Stacjonarnie lub online";
    }
    return statistics.location_name;
  };

  return (
    <section className="landing-statistics">
      <div className="landing-container">
        <div className="landing-section-header">
          <h2>{title}</h2>
        </div>

        <div className="landing-statistics-grid">
          <div className="landing-statistics-item">
            <div className="landing-statistics-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/>
              </svg>
            </div>
            <div className="landing-statistics-content">
              <div className="landing-statistics-label">Średnia cena:</div>
              <div className="landing-statistics-value">{statistics.avg_price} zł / sesja</div>
            </div>
          </div>

          <div className="landing-statistics-item">
            <div className="landing-statistics-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <div className="landing-statistics-content">
              <div className="landing-statistics-label">Czas odpowiedzi:</div>
              <div className="landing-statistics-value">{formatResponseTime()}</div>
            </div>
          </div>

          <div className="landing-statistics-item">
            <div className="landing-statistics-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <div className="landing-statistics-content">
              <div className="landing-statistics-label">Dostępni trenerzy:</div>
              <div className="landing-statistics-value">{statistics.available_trainers}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;